import React from 'react';
import GlobalStyle from './styles/GlobalStyle';
import { AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';
import Menu from './components/Menu';
import AgendaDocsIcon from './components/icons/AgendaDocsIcon';
import LogOutView from './components/LogOutView';
import { useUser } from './context/UserContext';
import { Container, Wrapper, Tools, Tool } from './styles/TableStyle';
import ReportDocsIcon from './components/icons/ReportDocsIcon';
import SignInIcon from './components/icons/SignInIcon';

function App() {
    const { roles } = useUser();
    return (
        <>
            <GlobalStyle />
            <AuthenticatedTemplate>
                <Container>
                    <Menu />
                    <Wrapper>
                        <div>
                            <h1>Välkommen till SEK Admin Tools!</h1>
                            <Tools>
                                <h4>Verktyg</h4>
                                <div>
                                    {roles && roles.includes('Agenda') && (
                                        <Tool
                                            to={{
                                                pathname: '/generate-agenda'
                                            }}
                                        >
                                            <div>
                                                <AgendaDocsIcon />
                                                <span>Agendagenerator</span>
                                            </div>
                                            <p>Med agendageneratorn automatiseras skapadet av mötesagendor i WORD-format (.docx)</p>
                                        </Tool>
                                    )}
                                    {roles && roles.includes('Report') && (
                                        <Tool
                                            to={{
                                                pathname: '/report-tools'
                                            }}
                                        >
                                            <div>
                                                <ReportDocsIcon /> 
                                                <span>Rapportgenerator</span>
                                            </div>
                                            <p>Med rapportgeneratorn automatiseras skapadet av diverse rapporter i PDF- och wordformat (.pdf, .docx)</p>
                                        </Tool>
                                    )}
                                    {roles && roles.includes('Visma') && (
                                        <Tool
                                            to={{
                                                pathname: '/visma'
                                            }}
                                        >
                                            <div>
                                                <SignInIcon />
                                                <span>Anslut till Visma</span>
                                            </div>
                                            <p>Ta fram en ny refresh token för en Visma-integration</p>
                                        </Tool>
                                    )}
                                </div>
                            </Tools>
                        </div>
                    </Wrapper>
                </Container>
            </AuthenticatedTemplate>
            <UnauthenticatedTemplate>
                <LogOutView />
            </UnauthenticatedTemplate>
        </>
    );
}

export default App;
